var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7082 9.89582V5.77082L48.5832 5.31249C48.354 5.31249 46.979 5.08332 44.6873 5.08332C35.2915 5.08332 28.4165 7.83332 24.5207 12.6458C21.5415 10.8125 17.4165 9.66665 12.604 9.66665C10.3123 9.66665 8.70817 9.89582 8.70817 9.89582L4.354 10.5833L4.58317 14.4792C4.81234 21.3542 8.24984 34.4167 20.1665 34.4167H20.6248V42.2083C11.9165 43.3542 4.58317 46.3333 4.58317 46.3333V50.9166H50.4165V46.3333C50.4165 46.3333 43.0832 43.3542 34.3748 42.2083V34.875C48.8123 34.6458 52.7082 18.375 52.7082 9.89582ZM27.4998 41.75H25.2082V28.9167C25.2082 28.9167 24.7498 21.125 18.3332 21.125C18.3332 21.125 21.7707 22.9583 22.6873 29.6042C21.7707 29.8333 20.854 29.8333 20.1665 29.8333C9.62484 29.8333 9.1665 14.4792 9.1665 14.4792C9.1665 14.4792 10.5415 14.25 12.604 14.25C16.9582 14.25 24.0623 15.1667 26.1248 21.3542C27.2707 11.0417 38.9582 9.66665 44.6873 9.66665C46.7498 9.66665 48.1248 9.89582 48.1248 9.89582C48.1248 9.89582 48.1248 30.5208 33.6873 30.5208H32.0832C32.0832 25.9375 36.6665 19.0625 36.6665 19.0625C29.7915 21.3542 29.7915 30.2917 29.7915 30.2917V41.75H27.4998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantWhite);
export default __webpack_public_path__ + "static/media/plantWhite.913fc642e2843db0c14cfa8a607e25d2.svg";
export { ForwardRef as ReactComponent };